var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRipristinoCompletoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16324"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 32h32v-32h-32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16340"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 32h32v-32h-32z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 42.667)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.68937 0 0 .68937 .99403 9.1706)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.6901 11.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 21.686,18.167 43.373,0 37.824,-9.542 21.686,4.02 5.549,-9.542 Z",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.68937 0 0 .68937 12.024 27.888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 14.497-12.383-4.366-5.164-10.135 8.592-10.131-8.599-4.366 5.164z",
    fill: "#008768"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.68937 0 0 .68937 .99403 9.1706)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16340)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.888 15.094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.3716 13.356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8552 11.579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.8012 16.704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.2848 14.966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.7683 13.189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.699 18.332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.1826 16.594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.666 14.817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.6134 19.94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.097 18.203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.58 16.426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.53 21.546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.014 19.808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.497 18.031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c.042-.196-.084-.39-.28-.431-.197-.042-.39.083-.432.28-.041.196.084.389.281.431.196.042.389-.084.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.108 15.101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.624 13.363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.141 11.586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.195 16.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.711 14.973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.228 13.196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.297 18.339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.814 16.601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.33 14.824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.383 19.947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.899 18.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.416 16.433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.466 21.553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.982 19.815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.499 18.038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.042-.196.084-.39.28-.431.197-.042.39.083.432.28.041.196-.084.389-.281.431-.196.042-.389-.084-.431-.28",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipristinoCompletoIcon);
export default __webpack_public_path__ + "static/media/RipristinoCompletoIcon.59d83ea7352ff3bedb71aa9c344e0880.svg";
export { ForwardRef as ReactComponent };